<!--
  Custom Textarea Input Component Template

  This template provides a styled textarea with label, helper text, and error text.
  Consistent with app-input component styling.
-->

<div class="textarea-wrapper space-y-3">
  <!-- Label -->
  @if (label()) {
  <app-input-label [for]="id()" [required]="required()">
    {{ label() }}
  </app-input-label>
  }

  <!-- Description -->
  @if (description()) {
  <p class="text-sm text-medium font-normal mt-0.5">
    {{ description() }}</p>
  }

  <!-- Textarea Container -->
  <div
    class="textarea-container"
    [class.theme-shadow]="shadow()"
    [class.theme-border]="border()"
    [class.disabled]="disabled"
    [class.readonly]="readonly()"
    [class.error]="errorText()"
    [ngClass]="customClass()"
  >
    <textarea
      #textareaElementRef
      [id]="id()"
      [name]="name()"
      [placeholder]="placeholder()"
      [disabled]="disabled"
      [readonly]="readonly()"
      [required]="required()"
      [rows]="rows()"
      [attr.minlength]="minlength()"
      [attr.maxlength]="maxlength()"
      [attr.autocapitalize]="autocapitalize()"
      [attr.autocorrect]="autocorrect()"
      [attr.spellcheck]="spellcheck()"
      [value]="value"
      class="textarea-field bg-surface"
      (input)="onTextareaInput($event)"
      (focus)="onFocusChange($event)"
      (blur)="onBlurChange($event)"
      (keydown)="onKeyDown($event)"
    ></textarea>
  </div>

  <!-- Helper Text -->
  @if (helperText() && !errorText()) {
  <div class="helper-text">
    {{ helperText() }}
  </div>
  }

  <!-- Error Text -->
  @if (errorText()) {
  <div class="error-text">
    {{ errorText() }}
  </div>
  }

  <!-- Character Count (if maxlength is set) -->
  @if (maxlength()) {
  <div class="character-count">{{ value.length || 0 }} / {{ maxlength() }}</div>
  }
</div>
